import LayoutMaintenance from './LayoutMaintenance.vue'
export default LayoutMaintenance



// WEBPACK FOOTER //
// ./src/layouts/LayoutMaintenance/index.js